var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSlackMark = function SvgSlackMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M4.25,12.616c0,1.147-0.937,2.085-2.083,2.085s-2.084-0.938-2.084-2.085s0.938-2.083,2.084-2.083H4.25 V12.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M5.3,12.616c0-1.147,0.937-2.083,2.083-2.083c1.147,0,2.083,0.936,2.083,2.083v5.217 c0,1.147-0.936,2.084-2.083,2.084c-1.146,0-2.083-0.937-2.083-2.084V12.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M7.383,4.25C6.236,4.25,5.3,3.313,5.3,2.167s0.937-2.084,2.083-2.084c1.147,0,2.083,0.938,2.083,2.084 V4.25H7.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M7.383,5.3c1.147,0,2.083,0.937,2.083,2.083c0,1.147-0.936,2.083-2.083,2.083H2.167 c-1.146,0-2.084-0.936-2.084-2.083c0-1.146,0.938-2.083,2.084-2.083H7.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M15.748,7.383c0-1.146,0.937-2.083,2.085-2.083c1.147,0,2.084,0.937,2.084,2.083 c0,1.147-0.937,2.083-2.084,2.083h-2.085V7.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M14.701,7.383c0,1.147-0.938,2.083-2.085,2.083s-2.083-0.936-2.083-2.083V2.167 c0-1.146,0.936-2.084,2.083-2.084s2.085,0.938,2.085,2.084V7.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M12.616,15.748c1.147,0,2.085,0.937,2.085,2.085c0,1.147-0.938,2.084-2.085,2.084 s-2.083-0.937-2.083-2.084v-2.085H12.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M12.616,14.701c-1.147,0-2.083-0.938-2.083-2.085s0.936-2.083,2.083-2.083h5.217 c1.147,0,2.084,0.936,2.084,2.083s-0.937,2.085-2.084,2.085H12.616z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlackMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack-mark.38cb69b8.svg";
export { ForwardRef as ReactComponent };